import { NextSeo } from 'next-seo';
import Head from 'next/head';

import parse from 'html-react-parser';
import isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import EmptyArticle from 'src/components/empty';
import GalleryLasted from 'src/components/gallery/gallery-lasted';
import Layout from 'src/components/layouts';
import {
  APP_URL,
  IS_NO_ROBOT_INDEX
} from 'src/constants';
import {
  IMAGE_DEFAULT,
  WEB_NAME,
  WEB_URL
} from 'src/constants/layout';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import {
  escapeChar,
  useDesktop
} from 'src/utils/helper';
import { GET } from 'src/utils/services';
import useUser from 'src/utils/useUser';

const PageGalleries = (props) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  const router = useRouter();
  const baseUrlCategory = `${APP_URL}${router.asPath}`;
  const { articles, meta, dataAdsHeader } = props;
  if (!articles) return <EmptyArticle sessionSevId={sessionSevId} />;

  /* -------------------------------- START : LOADMORE -------------------------------- */

  // const nextLinkRef = useRef(nextArticles.next);
  // const listArticlesRef = useRef(articles);
  // const [listArticles, setListArticles] = useState(articles);
  // const [isFetching, setIsFetching] = useState(false);

  // const handleScroll = async () => {
  //   if (isShouldFetch()) {
  //     document.removeEventListener('scroll', handleScroll);
  //     await loadMoreArticles();
  //   }
  // };

  // const loadMoreArticles = async () => {
  //   try {
  //     if (nextArticles?.next) {
  //       setIsFetching(true);
  //       const { data } = await useFetch(nextLinkRef.current);
  //       if (data) {
  //         nextLinkRef.current = data?.links?.next;
  //         listArticlesRef.current = [...listArticlesRef.current, ...data?.data];
  //         setListArticles(listArticlesRef.current);
  //       }
  //       if (!arrayEmpty(data?.data)) {
  //         if (isShouldFetch()) {
  //           await loadMoreArticles();
  //         } else {
  //           document.addEventListener('scroll', handleScroll);
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.error(`==========> LOAD_LOTTERY ERROR : ${nextLinkRef?.current}`, err);
  //   } finally {
  //     setIsFetching(false);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener('scroll', handleScroll);
  //   return () => document.removeEventListener('scroll', handleScroll);
  // }, []);

  /* ----------------------------- END : LOADMORE ----------------------------- */

  const _article = {
    title: `รวมอัลบั้มรูป : ${meta?.title ?? 'ไม่พบข้อมูล'}`,
    description: `รวมอัลบั้มรูป : ${meta?.description}`,
    keyword: `${meta?.keyword}`
  };
  // const cloneArticles = [...listArticles];
  // const cloneBlockSide = lastNews && [...lastNews.slice(0, 4)];

  const articleTitleSeo = escapeChar(_article?.title);
  const articleDescriptionSeo = escapeChar(_article?.description);

  return (
    <>
      <NextSeo
        noindex={IS_NO_ROBOT_INDEX}
        nofollow={IS_NO_ROBOT_INDEX}
        title={_article?.title}
        description={_article?.description}
        openGraph={{
          type: 'article',
          locale: 'th_TH',
          site_name: WEB_NAME,
          title: _article?.title,
          description: _article?.description,
          url: baseUrlCategory,
          images: [
            {
              url: IMAGE_DEFAULT,
              width: '1920',
              height: '1080',
              alt: WEB_NAME
            }
          ]
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: _article?.keyword
          }
        ]}
      />
      {/* --------------------------------- HEADER --------------------------------- */}
      <Head>
        <link rel='canonical' href={baseUrlCategory} />
        <meta property='twitter:title' content={_article?.title} />
        <meta property='twitter:description' content={_article?.description} />
        <meta property='twitter:image' content={IMAGE_DEFAULT} />

        {/* --------------------------------- Truehit -------------------------------- */}
        <script type='text/javascript' dangerouslySetInnerHTML={{
          __html: `
            __th_page="galleries";
          `
        }} />

        {/* ---------------------------- SNIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
            {
              "@context": "https://schema.org",
              "@type": "WebSite",
              "name": "${WEB_NAME}",
              "url": "${WEB_URL.WEB}",
              "description": "${articleDescriptionSeo}",
              "sameAs": [
                "${WEB_URL.FACEBOOK}",
                "${WEB_URL.TWITTER}",
                "${WEB_URL.YOUTUBE}",
                "${WEB_URL.LINE}"
              ],
              "potentialAction": {
                "@type": "SearchAction",
                "target": "${WEB_URL.WEB}search?q={search_term_string}",
                "query-input": "required name=search_term_string"
              }
            }
          `
          }}
        />

        {/* ---------------------------- SNIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                "@context": "http://schema.org",
                "@type": "WebPage",
                "name": "${articleTitleSeo}",
                "description": "${articleDescriptionSeo}",
                "publisher": {
                  "@type": "ProfilePage",
                  "name": "${WEB_NAME}"
                }
              }
            `
          }}
        />

        {/* ------------------------ SNIPPET : BreadcrumbList ------------------------ */}
        <script type='application/ld+json' dangerouslySetInnerHTML={{
          __html: ` 
              { 
                "@context": "http://schema.org", 
                "@type": "BreadcrumbList", 
                "itemListElement": [ 
                  { 
                    "@type": "ListItem", 
                    "position": 1, 
                    "name": "หน้าแรก", 
                    "item": "${APP_URL}" 
                  }, 
                  { 
                    "@type": "ListItem", 
                    "position": 2, 
                    "name": "${articleTitleSeo}", 
                    "item": "${baseUrlCategory}" 
                  } 
                ] 
              } 
            `
        }} />
        {!useDesktop() && !isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_mobile}`) : ''}
        {useDesktop() && !isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_desktop}`) : ''}

        </Head>
        <Layout sessionSevId={sessionSevId} >
        <h1 className='head-seo'>{`${_article?.title ?? 'ไม่พบข้อมูล'}`}</h1>
        <GalleryLasted {...props} />

      </Layout>
    </>
  );
};
export async function getServerSideProps ({ req, res, query }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    articles: null,
    lastNews: null,
    meta: null,
    nextArticles: null,
    dataAdsHeader: null
  };
  try {
    const resData = await GET('/api/v1.0/gallery/categories/latest-galleries', false, true);
    const adsHeaders = await GET('/api/headerAds');
    if (!isEmpty(adsHeaders)) {
      initProps.dataAdsHeader = adsHeaders;
    }
    if (!isEmpty(resData?.data)) {
      initProps.articles = (resData.data) || [];
      initProps.meta = resData.meta || {};
      initProps.nextArticles = resData.links || {};
      initProps.lastNews = resData.last_news || [];
      initProps.ads = resData.ads || [];
    }
  } catch (err) {
    console.log('==========> LOTTERY ERROR', err?.message);
    initProps.errMessage = err?.message;
    initProps.statusCode = err?.response?.status || 500;

    res.statusCode = initProps.statusCode;
    res.end();
  }

  return {
    props: initProps
  };
}

export default PageGalleries;
